import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import theme from 'shared/styles/theme';

export const LOGO_COLOR_MAP = {
  purple: theme.color.expressive.varoPurple,
  white: theme.color.text.inverse,
  black: theme.color.text.primary,
};

interface VaroLogoProps {
  /**
   * @default 'purple'
   */
  color?: keyof typeof LOGO_COLOR_MAP;

  /**
   * @default '100%'
   */
  width?: number | string;

  /**
   * @default '100%'
   */
  height?: number | string;

  style?: ViewStyle;
}

const VaroLogo = ({
  color = 'purple',
  width = '100%',
  height = '100%',
  style,
}: VaroLogoProps) => {
  return (
    <View
      style={[styles.container, { width, height }, style]}
      accessible
      accessibilityLabel="varo-logo"
      accessibilityRole="image"
      role="img"
    >
      <Svg viewBox="0 0 88 32" preserveAspectRatio="xMidYMid meet">
        <Path
          d="M1.83887 0.4375H9.67032L14.4372 16.3979C15.1181 18.6963 15.8419 21.7609 15.8419 21.7609H15.9271C15.9271 21.7609 16.6932 18.6539 17.3318 16.3979L22.0559 0.4375H29.6746L19.6723 30.8691H11.8836L1.83887 0.4375Z"
          fill={LOGO_COLOR_MAP[color]}
        />
        <Path
          d="M26.0927 24.7827C26.0927 19.9731 29.923 18.5259 34.4347 17.9301C38.5206 17.4195 39.9677 16.9936 39.9677 15.5041C39.9677 14.0994 39.0736 13.1633 36.9883 13.1633C34.775 13.1633 33.6682 14.1422 33.4559 15.9724H27.0712C27.2415 11.9289 30.3485 8.48163 36.9455 8.48163C40.2229 8.48163 42.4361 9.07744 44.0108 10.269C45.8834 11.631 46.7775 13.7591 46.7775 16.4834L46.8016 30.8691L40.1249 30.8687L40.0953 28.4431H40.0101C38.7333 30.2733 36.818 31.4225 33.5406 31.4225C29.1997 31.4225 26.0927 29.0813 26.0927 24.7827ZM40.1381 23.08V20.4837C39.244 20.9519 37.9676 21.2926 36.5628 21.6329C33.8813 22.2287 32.265 22.8413 32.3494 24.7831C32.4338 26.7268 33.8747 27.1208 35.7543 26.9956C38.5191 26.812 40.1381 24.9526 40.1381 23.08Z"
          fill={LOGO_COLOR_MAP[color]}
        />
        <Path
          d="M49.0998 9.07741H55.7393V12.4823H55.8668C57.3991 9.88595 59.1869 8.73712 61.8253 8.73712C62.4639 8.73712 62.8897 8.77951 63.1872 8.90707V14.8659H63.0173C58.7611 14.2701 56.0372 16.3554 56.0372 21.0799V30.8691H49.0994L49.0998 9.07741Z"
          fill={LOGO_COLOR_MAP[color]}
        />
        <Path
          d="M62.9052 20.0159C62.9052 13.4612 67.5872 8.48163 74.5669 8.48163C81.5898 8.48163 86.1863 13.4612 86.1863 20.0159C86.1863 26.5705 81.5898 31.5501 74.5669 31.5501C67.5868 31.5501 62.9052 26.5705 62.9052 20.0159ZM79.5095 20.0159C79.5095 16.0576 77.5463 13.3764 74.5245 13.3764C71.5027 13.3764 69.5368 16.0576 69.5368 20.0159C69.5368 23.9742 71.5027 26.6129 74.5245 26.6129C77.5463 26.6129 79.5095 23.9742 79.5095 20.0159Z"
          fill={LOGO_COLOR_MAP[color]}
        />
      </Svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    resizeMode: 'contain',
  },
});

export default VaroLogo;
